import { css } from '@emotion/react'
import custom from 'shared/styles/custom.styles'

const styles = () => {
    return {
        assetNumber: css`
            ${custom.stepElementPadding};
            font-weight: bold;
        `,
        text: custom.stepText,
    }
}

export default styles
